/**
 * @generated SignedSource<<ab45aa35523c12605da87f237b50b3f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactByEmailInput = {
  accountID: string;
  email: string;
};
export type contactByEmailQuery$variables = {
  input: ContactByEmailInput;
};
export type contactByEmailQuery$data = {
  readonly contactByEmail: {
    readonly " $fragmentSpreads": FragmentRefs<"contactsInlineFragment">;
  } | null;
};
export type contactByEmailQuery = {
  variables: contactByEmailQuery$variables;
  response: contactByEmailQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unmindUserId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "SessionLimitPayload",
  "kind": "LinkedField",
  "name": "sessionLimits",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionLimitType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountRemaining",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiryDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasActiveEventRequest",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contactByEmailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Contact",
        "kind": "LinkedField",
        "name": "contactByEmail",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "contactsInlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactTeamMember",
                "kind": "LinkedField",
                "name": "contactTeamMembers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "teamMember",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "memberUserProfile",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "kind": "InlineDataFragmentSpread",
                "name": "contactSessionLimitsRemainingInlineFragment",
                "selections": [
                  (v11/*: any*/)
                ]
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "contactHasActiveEventRequestInlineFragment",
                "selections": [
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contactByEmailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Contact",
        "kind": "LinkedField",
        "name": "contactByEmail",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactTeamMember",
            "kind": "LinkedField",
            "name": "contactTeamMembers",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMember",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "memberUserProfile",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9aa821ebdd4df1252ccccdbb0fca1909",
    "id": null,
    "metadata": {},
    "name": "contactByEmailQuery",
    "operationKind": "query",
    "text": "query contactByEmailQuery(\n  $input: ContactByEmailInput!\n) {\n  contactByEmail(input: $input) {\n    ...contactsInlineFragment\n    id\n  }\n}\n\nfragment contactHasActiveEventRequestInlineFragment on Contact {\n  hasActiveEventRequest\n}\n\nfragment contactSessionLimitsRemainingInlineFragment on Contact {\n  sessionLimits {\n    sessionLimitType\n    amountRemaining\n    expiryDate\n  }\n}\n\nfragment contactsInlineFragment on Contact {\n  id\n  firstName\n  lastName\n  source\n  email\n  accountId\n  createdAt\n  createdBy\n  contactTeamMembers {\n    id\n    teamMember {\n      id\n      memberUserProfile {\n        firstName\n        lastName\n        id\n      }\n    }\n  }\n  unmindUserId\n  ...contactSessionLimitsRemainingInlineFragment\n  ...contactHasActiveEventRequestInlineFragment\n}\n"
  }
};
})();

(node as any).hash = "7de2f63044bc273654029662ba3b74fd";

export default node;
